// Extend namespace by creating a new object
pyzel.submenus = {};

/**
 * Initialize listeners
 *
 * @return {void}
 */
pyzel.submenus.init = function() {

	// Show the submenu
	$('.js-show-submenu').on('mouseenter', function(){
		pyzel.submenus.show( $(this) );
	});

	// Hide the submenu
	$('.js-hide-submenu').on('mouseenter', function(){
		pyzel.submenus.hide();
	});

	// Hide the submenu
	$('.js-navbar').on('mouseleave', function(){
		pyzel.submenus.hide();
	});


	// Show the submenu
	$('.js-show-submenu').on('click', function(){
		pyzel.submenus.showMobile( $(this) );
	});

	// Hide the submenu
	$('.js-hide-submenu').on('click', function(){
		pyzel.submenus.hideMobile();
	});

};



/**
 * Show the submenu
 *
 * @param {object} el Selected element
 *
 * @return void
 */
pyzel.submenus.show = function(el) {

	// Only runs on desktop version
	if ( !$('.js-menu-mobile-toggle').is(':visible') ) {

		var submenu = el.data('submenu');

		// Just in case a submenu is still visible
		$('.js-submenu ul').hide();
		$('.js-show-submenu').removeClass('arrow');

		// Show the menu options
		$('.js-submenu-' + submenu).show();

		// Insert arrow
		el.addClass('arrow');

		// Animate
		$('.js-submenu').stop().slideDown();

	}

};



/**
 * Hides the submenu
 *
 * @return void
 */
pyzel.submenus.hide = function () {

	// Only runs on desktop version
	if ( !$('.js-menu-mobile-toggle').is(':visible') ) {
		$('.js-submenu').stop().slideUp(function(){
			$('.js-submenu ul').hide();
			$('.js-show-submenu').removeClass('arrow');
		});
	}

};



/**
 * Show the submenu in mobile
 *
 * @param {object} el Selected element
 *
 * @return void
 */
pyzel.submenus.showMobile = function(el) {

	// Only runs on mobile
	if ( $('.js-menu-mobile-toggle').is(':visible') ) {

		// Just in case a submenu is still visible
		$('.js-submenu ul').hide();

		var submenu = el.data('submenu');

		// Show the menu options
		$('.js-submenu-' + submenu).show();
		$('.js-submenu').css('marginLeft', '100%').show().stop().animate({ marginLeft: "0%"} , 800);

	}

};



/**
 * Hide the submenu in mobile
 * @return void
 */
pyzel.submenus.hideMobile = function() {

	// Only runs on mobile
	if ( $('.js-menu-mobile-toggle').is(':visible') ) {
		$('.js-submenu').stop().animate({ marginLeft: "100%"} , 500);
	}

};